<template>
  <v-checkbox
    v-model="isEnabled"
    @change="updateSelectedData"
    :label="'Include Final ' + averageType + ' Scores'"
  />
</template>

<script setup>
import {computed, ref} from 'vue'
const props = defineProps({
  enabledSiiScores: {
    type:Boolean,
    default:false,
    required: false
  },
  isSpiOrSii: {
    type: String,
    required: false,
    default: 'sii'
  }
})

const emit = defineEmits(['update-data'])
function updateSelectedData(){
  emit('update-data', isEnabled.value)
}

const averageType= computed(()=>{
  if(props.isSpiOrSii === 'sii') return 'SII'
  else return 'SPI'
})
const isEnabled= ref(false)

</script>

<style scoped>

</style>
